import React, { useEffect, useState } from "react";
import StatusComp from "../../../components/StatusComp";
import { Table } from "../../../components/Table/Table";
import { get } from "../../../Services/ApiHandler";
import { URL } from "../../../Services/Constant";

const GroupEscalationTime = () => {
  const userData = JSON.parse(localStorage.getItem("user_details"));

  const [groupEscalations, setGroupEscalations] = useState([]);

  const getList = () => {
    get(URL.GROUP_USERS + userData?.knf_company_site_id)
      .then((res) => {
        if (res?.data?.escalations?.length > 0) {
          setGroupEscalations(res?.data?.escalations);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getList();
  }, []);

  const columns = React.useMemo(() => [
    {
      Header: "S.No",
      accessor: "sno",
      Cell: ({ value, row }) => {
        return <p>{row.index + 1}</p>;
      },
    },
    {
      Header: "Escalation type",
      accessor: "from_group",
      Cell: ({ value, row }) => {
        return (
          <p>
            {" "}
            {row?.original?.from_group
              ? `Group  ${row?.original?.from_group} `
              : ""}
            {row?.original?.to_group
              ? `→ Group  ${row?.original?.to_group}`
              : ""}
          </p>
        );
      },
    },
    {
      Header: "Severity type",
      accessor: "severity",
      Cell: ({ value, row }) => {
        return <p className="ms-4">{value}</p>;
      },
    },
    {
      Header: "Value ( in minutes)",
      accessor: "escalation_minutes",
      Cell: ({ value, row }) => {
        return <p className="ms-4">{value}</p>;
      },
    },
  ]);

  return (
    <div className="dashRightView">
      <StatusComp name={"Alert Escalation Time Settings"} hide={true} />

      <Table columns={columns} data={groupEscalations} />
    </div>
  );
};

export default GroupEscalationTime;
